export default __webpack_public_path__ + "static/media/Group 8706_10.e8bd7762.png";